// extracted by mini-css-extract-plugin
var _1 = "DzGOH5lv";
var _2 = "Rxg7D5xg";
var _3 = "dCZTflmo";
var _4 = "ieRgs7mj";
var _5 = "DzGOH5lv";
var _6 = "Rxg7D5xg";
var _7 = "dCZTflmo";
var _8 = "ieRgs7mj";
export { _1 as "page-back-link", _2 as "page-heading", _3 as "page-heading-top-row", _4 as "page-sub-header", _5 as "pageBackLink", _6 as "pageHeading", _7 as "pageHeadingTopRow", _8 as "pageSubHeader" }
